import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
const queryClient = new QueryClient();
const ClientProvider = ({ children }) => (React.createElement(QueryClientProvider, { client: queryClient },
    children,
    React.createElement(ReactQueryDevtools, { initialIsOpen: false })));
export default ClientProvider;
